import { handleActions } from 'redux-actions'

import { showBackdropMessage } from './actions'

export const INITIAL_STATE = {
  backdrop: {
    show: false,
    messages: [] as string[]
  }
}

export type BackdropMessageState = typeof INITIAL_STATE.backdrop

type State = typeof INITIAL_STATE

export const messageReducer = handleActions<State, string[]>(
  {
    [showBackdropMessage.toString()]: (state, { payload }) => ({
      ...state,
      backdrop: {
        show: true,
        messages: payload
      }
    })
  },
  INITIAL_STATE
)
